import Header from "../components/Header";
import MainContent from "../components/MainContent";

function Home() {
    return (
        <div> 
            <Header />
            <MainContent />
        </div>
    );
}

export default Home;